var BulkLoadListStatus;
(function (BulkLoadListStatus) {
    BulkLoadListStatus[BulkLoadListStatus["EXPIRED"] = 0] = "EXPIRED";
    BulkLoadListStatus[BulkLoadListStatus["UNDER_REVIEW"] = 1] = "UNDER_REVIEW";
    BulkLoadListStatus[BulkLoadListStatus["PARTIAL_PUBLISHED"] = 2] = "PARTIAL_PUBLISHED";
    BulkLoadListStatus[BulkLoadListStatus["PUBLISHED"] = 3] = "PUBLISHED";
    BulkLoadListStatus[BulkLoadListStatus["PARTIAL_FULFILLED"] = 4] = "PARTIAL_FULFILLED";
    BulkLoadListStatus[BulkLoadListStatus["FULFILLED"] = 5] = "FULFILLED";
})(BulkLoadListStatus || (BulkLoadListStatus = {}));
var BulkLoadListStatusText;
(function (BulkLoadListStatusText) {
    BulkLoadListStatusText["EXPIRED"] = "Expired";
    BulkLoadListStatusText["UNDER_REVIEW"] = "Under Review";
    BulkLoadListStatusText["PARTIAL_PUBLISHED"] = "Partially Published";
    BulkLoadListStatusText["PUBLISHED"] = "Published";
    BulkLoadListStatusText["PARTIAL_FULFILLED"] = "Partially Fulfilled";
    BulkLoadListStatusText["FULFILLED"] = "Fulfilled";
})(BulkLoadListStatusText || (BulkLoadListStatusText = {}));

export { BulkLoadListStatus, BulkLoadListStatusText };
//# sourceMappingURL=bulkLoadListCardStatusMap.js.map
